import styled from 'styled-components';

const Rodape = styled.div`
  display: grid;
  justify-content: center;
  align-items: end;
  p {
    font-family: 'Open Sans', sans-serif;
  }
`;

export default Rodape;
